import styled from '@emotion/styled'
import { mq } from './../utility/breakpoint'

export const Spacer = styled.div`
  margin: 95px 0;
  ${mq[3]} {
    margin: 195px 0;
  }
`
